export default [
    "AFGHANIS",
    "AMSAMOA",
    "ANDORRA",
    "ANGUILLA",
    "ANTIGUA",
    "ARUBA",
    "BAHAMAS",
    "BARBADOS",
    "BELIZE",
    "BERMUDA",
    "BHUTAN",
    "BES",
    "BVI",
    "BURKINA",
    "BURUNDI",
    "CABOVERDE",
    "CAYMAN",
    "CAFRICREP",
    "CHAD",
    "MACAO",
    "COMOROS",
    "COOK",
    "DJIBOUTI",
    "DOMINICA",
    "ESWATINI",
    "EQGUINEA",
    "MALVINAS",
    "FAROE",
    "FIJI",
    "FGUYANA",
    "FPOLYNESIA",
    "GAMBIA",
    "GREENLAND",
    "GRENADA",
    "GUADELOUPE",
    "GUAM",
    "GUERNSEY",
    "GUINEA",
    "GUINEABIS",
    "GUYANA",
    "MANISLE",
    "JERSEY",
    "KIRIBATI",
    "LAO",
    "LESOTHO",
    "LIBERIA",
    "LIECHTENST",
    "MADAGASCAR",
    "MALAWI",
    "MALDIVES",
    "MALI",
    "MARSHALL",
    "MARTINIQUE",
    "MAURITANIA",
    "MAYOTTE",
    "MICRONESIA",
    "MONTSERRAT",
    "NAURU",
    "CALEDONIA",
    "NIUE",
    "NMARIANA",
    "PALAU",
    "PAPUA",
    "PUERTORICO",
    "REUNION",
    "RWANDA",
    "SHELENA",
    "SKITTS",
    "SLUCIA",
    "SPIERRE",
    "SVINCENT",
    "SAMOA",
    "SAOTOME",
    "SEYCHELLES",
    "SIERRALEO",
    "SMAARTEN",
    "SOLOMON",
    "SOMALIA",
    "PALESTINE",
    "TIMORLESTE",
    "TONGA",
    "TURKSCAIC",
    "TUVALU",
    "UGANDA",
    "USVI",
    "VANUATU",    
];